export default "__VITE_PUBLIC_ASSET__f7df6b33__"